function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from "react";
import { element, node, shape, func, string } from "prop-types";
import { components } from "react-select";
import { CellApply } from "#library/components/SelectFilter/customComponents/CellApply/CellApply";
import { OptionCheckbox } from "#library/components/SelectFilter/customComponents/Option/OptionCheckbox";
import { selectTypes } from "#library/components/SelectFilter/Select/types/types";
import styles from "./MenuList.module.css";
export var MenuListCheckbox = function MenuListCheckbox(props) {
  var blurInput = props.blurInput,
    children = props.children,
    clearValue = props.clearValue,
    closeMenu = props.closeMenu,
    getValue = props.getValue,
    setValue = props.setValue,
    options = props.options,
    _props$selectProps = props.selectProps,
    informationCell = _props$selectProps.informationCell,
    linkCell = _props$selectProps.linkCell,
    clearLabel = _props$selectProps.clearLabel,
    applyLabel = _props$selectProps.applyLabel,
    selectAllLabel = _props$selectProps.selectAllLabel,
    _onApply = _props$selectProps.onApply;

  // Options can be grouped. This method remove groups to flatten options
  var flattenOptions = useMemo(function () {
    return options.reduce(function (acc, val) {
      return val.options ? acc.concat(val.options) : acc.concat(val);
    }, []);
  }, [options]);

  // get all options already selected
  var selectedOptions = getValue();

  // Boolean to know if all options are selected
  // if true, this mean that the select all should also be displayed as selected
  var areAllOptionsSelected = flattenOptions.length === selectedOptions.length;

  // Boolean to know if at least one options is selected
  // if true, this mean that the select all should also be displayed as intermediate
  var isOneOptionsSelected = selectedOptions.length > 0;
  var selectAllClick = function selectAllClick() {
    if (areAllOptionsSelected) {
      clearValue();
    } else {
      setValue(flattenOptions, "select-option");
    }
  };
  return /*#__PURE__*/React.createElement(components.MenuList, props, selectAllLabel && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styles["jds-MenuList__block"],
    onClick: selectAllClick,
    onKeyDown: selectAllClick
  }, /*#__PURE__*/React.createElement(OptionCheckbox, _extends({}, props, {
    data: [],
    isIndeterminate: isOneOptionsSelected,
    isSelected: areAllOptionsSelected,
    isFocused: false
  }), selectAllLabel)), informationCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, informationCell), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__footer"]
  }, linkCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, linkCell), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, /*#__PURE__*/React.createElement(CellApply, {
    onApply: function onApply() {
      _onApply(selectedOptions);

      // should delay close menu to not be on the same rendering timing as onApply
      setTimeout(function () {
        blurInput();
        closeMenu();
      }, 300);
    },
    disabled: selectedOptions.length === 0,
    clearLabel: clearLabel,
    applyLabel: "".concat(applyLabel, " (").concat((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) || "0", ")"),
    onClear: clearValue
  }))));
};
MenuListCheckbox.propTypes = {
  children: node.isRequired,
  selectProps: shape({
    informationCell: element,
    linkCell: element,
    clearLabel: string,
    applyLabel: string,
    selectAllLabel: string,
    onApply: func
  }).isRequired,
  getValue: func.isRequired,
  setValue: func.isRequired,
  options: selectTypes.options.isRequired,
  clearValue: func.isRequired,
  closeMenu: func.isRequired,
  blurInput: func.isRequired
};